











































import { Component, Vue } from 'vue-property-decorator';
import PageContent from '@/components/PageContent.vue';
import Archive from '@/components/Archive.vue';
import { CardData } from '@/types/cardData';

@Component({
  name: 'App',
  components: { PageContent, Archive },
})

export default class App extends Vue {
  public archivedCards: CardData[] = []
  public cards = [
    {
      title: 'Выучить Vue',
      value: 'Всё знать и разбираться',
      date: '2022-01-01',
      is_main: true,
    },
    {
      title: 'Выучить React',
      value: 'Всё знать и разбираться',
      date: '2022-01-01',
      is_main: true,
    },
    {
      title: 'Выучить Angular',
      value: 'Всё знать и разбираться',
      date: '2022-01-01',
      is_main: true,
    },
    {
      title: 'Выучить стихотворение',
      value: 'Всё знать и разбираться, Всё знать и разбираться, Всё знать и разбираться, Всё знать и разбираться',
      date: '2021-01-01',
      is_main: false,
    }
  ]
  public isBlockVisible: boolean = true

  public setCardToArchive(archivedCard: CardData[]): void {
    this.archivedCards.push(archivedCard[0]);
  }

  public setVisibility(): void {
    this.isBlockVisible = !this.isBlockVisible;
  }

  public cardCounter(count: string): string {
    return count
  }
}

